export const checkChecklistCondition = (item, response) => {
    let condition = (!item.shifts || (item.shifts.indexOf(response.shiftName) !== -1) || item.shifts.length === 0);
    if (item?.settings?.conditions?.length > 0) {
        item.settings.conditions.forEach((cond) => {
            condition = cond?.conditional_values?.indexOf(response?.[cond?.conditional_field]) !== -1;
        });
    }
    return condition;
};
